import { safeHtml } from '@/helpers/safeHtml';
import { AppKeyEnum, PlatformEnum } from '@/constants';
import { useGetHolidayBannerQuery } from '@/redux/api/cms.caller';
import { Banner, BlockStack } from '@shopify/polaris';
import { useEffect, useMemo, useState } from 'react';

const BANNER_STORAGE_KEY = 'hide_banner_key';

const NoticeBanner = () => {
  const [isHide, setIsHide] = useState<Record<string, boolean>>(JSON.parse(sessionStorage.getItem(BANNER_STORAGE_KEY) || '{}'));

  const { data } = useGetHolidayBannerQuery({
    appKey: AppKeyEnum.OrderTracking,
    platform: PlatformEnum.Shopify,
  });

  const bannerList = useMemo(() => {
    if (data && data.data) {
      return data.data
        .map((banner) => {
          if (!banner.isActive) return undefined;
          const { bannerTranslations, ...rest } = banner;

          const activeTranslations = bannerTranslations.filter((t) => t.isActive);
          const translation = activeTranslations.find((t) => t.languageCode === 'en') || activeTranslations[0];

          if (!translation) return undefined;

          return {
            ...rest,
            title: translation.title,
            description: translation.description,
          };
        })
        .filter((banner) => !!banner);
    }
    return [];

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(data)]);

  const handleHideBanner = (key: string) => {
    setIsHide((prev) => ({ ...prev, [key]: true }));
  };

  useEffect(() => {
    sessionStorage.setItem(BANNER_STORAGE_KEY, JSON.stringify(isHide));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(isHide)]);

  return (
    <BlockStack>
      {bannerList.map((banner) =>
        !isHide[banner?.bannerKey || ''] ? (
          <Banner
            key={banner?.id}
            title={banner?.title}
            onDismiss={banner?.isShowDismissBtn ? () => handleHideBanner(banner?.bannerKey || '') : undefined}
            tone={banner?.tone}
          >
            <BlockStack>
              {banner?.description.map((description) => (
                <div
                  key={description}
                  dangerouslySetInnerHTML={{
                    __html: safeHtml(description, 'NoticeBanner'),
                  }}
                />
              ))}
            </BlockStack>
          </Banner>
        ) : null,
      )}
    </BlockStack>
  );
};

export default NoticeBanner;
